// extracted by mini-css-extract-plugin
export default {"FlyingTicket":"FlyToCartAnimation_FlyingTicket__OAf3D"};